(ns bp-clients.tv-app.nav.views.login-page
  "Namespace for login page view for when user is logged-out"
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.auth.events :as auth-events]
   [bp-clients.tv-app.auth.subs :as auth-subs]
   [bp-libs.design-system.components.buttons :refer [Button]]
   [bp-libs.design-system.components.icons :refer [bp-original]]
   [bp-libs.design-system.components.qr-code :refer [code-component qr-code-component]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn- login-page
  "Login page"
  [{:keys [login-code qr-code-url on-new-code-request loading-error? main-focus-ref]}]
  [:main {:class "relative min-h-screen w-full dark-green-gradient overflow-hidden overscroll-contain"}
   [:div {:class "py-[3em] flex flex-col text-white space-y-4"}
    [:div {:class "flex flex-col items-center w-full space-y-6"}
     [:div {:class "flex items-center justify-center w-full"}
      [bp-original {:width "5%" :height "5%"}]]
     [:div {:class "uppercase text-2xl"} "entre na sua conta"]]
    [:div {:class "flex w-full items-start justify-center space-x-16"}
     [:div {:class "w-[40vw] space-y-6 flex flex-col"}
      [:div {:class "text-gray-400 text-3xl font-bold"} "Opção 1"]
      [:div {:class "font-bold text-5xl"} "Escaneie este código QR"]
      [:div {:class "text-2xl"} "Abra a câmera do celular ou o leitor de códigos QR e aponte para esta imagem."]
      [qr-code-component qr-code-url loading-error?]]
     [:div {:class "w-[40vw] space-y-6 flex flex-col"}
      [:div {:class "text-gray-400 text-3xl font-bold"} "Opção 2"]
      [:div {:class "font-bold text-5xl"} "Use uma página da Web"]
      [:ul {:class "list-none pl-4 space-y-16 text-2xl w-full m-0 p-0"}
       [:li
        [:div {:class "space-y-6 flex flex-col w-full"}
         [:div "1. No navegador do computador ou do celular acesse:"]
         [:div {:class "font-bold px-8 py-3.5 bg-black text-3xl w-full text-center rounded-lg"}
          "plataforma.brasilparalelo.com.br/tv"]]]
       [:li
        [:div {:class "space-y-6 flex flex-col justify-center"}
         [:div "2. Digite o código abaixo:"]
         [code-component login-code loading-error?]]]]]]
    [:div {:class "flex items-center justify-center text-lg"}
     [Button {:color         "gray"
              :tab-index     10
              :react-ref     main-focus-ref
              :extra-classes ["px-4 outline-none text-2xl"]
              :on-click      on-new-code-request}
      "Obter um novo código"]]]])

(defn login-page-with-focus []
  (let [login-code         (rf/subscribe [::auth-subs/login-code])
        qr-code-url        (rf/subscribe [::auth-subs/qr-code-url])
        fatal-error-login? (rf/subscribe [::auth-subs/fatal-login-error?])
        main-focus-ref     (createRef)]
    (fn []
      (r/create-class
       {:component-did-mount (fn [_react-component]
                               (when-let [main-button main-focus-ref.current]
                                 (.focus main-button)))
        :reagent-render      (fn [_props]
                               [login-page {:login-code          @login-code
                                            :on-new-code-request #(rf/dispatch [::auth-events/fetch-login-token])
                                            :main-focus-ref      main-focus-ref
                                            :loading-error?      @fatal-error-login?
                                            :qr-code-url         @qr-code-url}])}))))
